<script>
    import { Navbar, NavbarBrand, Icon } from "sveltestrap";
</script>

<Navbar color="white" light sticky="top" class="border-bottom">
    <!-- <Navbar color="white" light class="py-0 my-0"> -->
    <NavbarBrand href="#/">
        <Icon name="journal-richtext" class="" style="font-size: 2rem;" />
        mdEdit 3
    </NavbarBrand>
    <!-- <h1 class="h5 px-3 py-0 my-0"> -->
    <!-- <Icon name="journal-richtext" class="" style="font-size: 2rem;" /> -->
    <!-- <a href="/">mdEdit 3</a> -->
    <!-- </h1> -->
</Navbar>

<style>
</style>
